import type { BigNumber, BigNumberLike } from "@opensea/utils"
import { bn } from "@opensea/utils"

export function getFloorPriceDifference(
  floorPriceUsd: BigNumberLike | undefined,
  totalValueUsd: BigNumberLike | undefined,
  quantity: BigNumberLike,
): BigNumber | undefined {
  if (totalValueUsd === undefined || floorPriceUsd === undefined) {
    return undefined
  }
  if (bn(totalValueUsd).isNaN() || bn(totalValueUsd).isZero()) {
    return undefined
  }
  if (bn(quantity).isNaN() || bn(quantity).isZero()) {
    return undefined
  }
  if (bn(floorPriceUsd).isZero()) {
    return undefined
  }
  return bn(totalValueUsd)
    .div(bn(quantity))
    .minus(bn(floorPriceUsd))
    .div(bn(floorPriceUsd))
}
